var map = {
	"./01_thumbnail.jpg": 379,
	"./02_thumbnail.jpg": 380,
	"./03_thumbnail.jpg": 381,
	"./04_thumbnail.jpg": 382,
	"./07_thumbnail.jpg": 383,
	"./2ATH3BK.crop.jpg": 384,
	"./ABENT3.crop_thumb.jpg": 385,
	"./Around-img-1.jpg": 386,
	"./Around-img-1@2x.jpg": 387,
	"./Crater17-Chuvilin.jpg": 388,
	"./Footer-Desktop.jpg": 389,
	"./Footer-Mobile.jpg": 390,
	"./Footer-Tablet.jpg": 391,
	"./GettyImages-1229380660_thumbnail.jpg": 392,
	"./GettyImages-683364764_crop.jpg": 393,
	"./James-wong-article-thumbnail.jpg": 394,
	"./James-wong-thumbnail.jpg": 395,
	"./LNC-aggregates-on-sand-2-crop.jpg": 396,
	"./Mountain_pines_Uttarakhand_cred_Alamy.jpg": 397,
	"./Opt_out_bell.svg": 398,
	"./Opt_out_message.svg": 399,
	"./Seawatergreenhouseaus_crop.jpg": 400,
	"./The_miller_delivering_flour_to_people_homes.jpg": 401,
	"./Thought-leaders-thumbnail.jpg": 402,
	"./Water_hyacinth_GettyImages-170500069.jpg": 403,
	"./about-icon.png": 404,
	"./add-to-home.png": 405,
	"./add-to-home.svg": 406,
	"./aerial.jpg": 407,
	"./africa_getty.jpg": 408,
	"./arrow_icon.svg": 409,
	"./arrow_right.svg": 410,
	"./bbc-logo.png": 411,
	"./bbc-storyworks-logo.png": 412,
	"./bug.jpg": 413,
	"./cattle-drones-thumbnail.jpg": 414,
	"./cityFarms.jpg": 415,
	"./client-logo-white-02.svg": 416,
	"./client-logo.png": 417,
	"./client-logo.svg": 418,
	"./client-logo2.png": 419,
	"./coffee.jpg": 420,
	"./crops.png": 421,
	"./external_1.jpg": 422,
	"./external_2.jpg": 423,
	"./external_3.jpg": 424,
	"./external_4.jpg": 425,
	"./farmer.jpg": 426,
	"./farming-in-forests-article.jpg": 427,
	"./farms.png": 428,
	"./food-chain-thumbnail-article.jpg": 429,
	"./hero_getty.jpg": 430,
	"./how-covid-19-is-changing-food-shopping.jpg": 431,
	"./how_algae_could_transform_diets_article.jpg": 432,
	"./kiwi-picker-robotics.jpg": 433,
	"./leftArrow.svg": 434,
	"./mineral.png": 435,
	"./miracles_in_a_crisis.jpg": 436,
	"./opt-in-bar.svg": 437,
	"./plastic-problem-article.jpg": 438,
	"./rightArrow.svg": 439,
	"./rooftop.jpg": 440,
	"./save_the_bees_article.jpg": 441,
	"./the-fisherman-selling-his-catch-on-social-media.jpg": 442,
	"./the-freedom-soup-saving-a-city.jpg": 443,
	"./the-green-milk-made-from-cells.jpg": 444,
	"./the-massive-farms-emerging-beneath-our-cities.jpg": 445,
	"./the-simple-shellfish-that-fights-climate-change-thumbnail.jpg": 446,
	"./the-urban-farm-sending-meals-to-children.jpg": 447,
	"./the_invisible_women_article.jpg": 448,
	"./update-bar.svg": 449
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;